<template>
  <div class="row spinner-parent menu-edit-wrapper">
    <spinner ref="spinner" size="md" text="Loading ..." />

    <div v-if="source" class="col-md-12">
      <div class="col-12">
        <div class="card">
          <div class="card-header">
            <h1>Manage terms order in vocabulary {{ source.name }}</h1>
          </div>
        </div>
      </div>

      <div class="col-12">
        <div class="card-header">
          <strong>Builder</strong>
          <router-link
            class="btn btn-primary btn-sm pull-right"
            :to="{ name: 'VocabularyEdit', params: { id: $route.params.id }}"
          >
            Edit vocabulary
          </router-link>
        </div>
        <div class="card form-horizontal">
          <div class="row">
            <div class="col-12">
              <div class="card-block">
                <div v-if="orderChanged" class="alert alert-warning">
                  Items order changed. Don't forget to save it!
                </div>

                <div class="menu-builder">
                  <div class="menu-builder__btns">
                    <button class="btn btn-primary" @click="addItemToTop">Add item</button>
                  </div>

                  <div class="menu-builder-inner">
                    <ul v-if="faqTree.length">
                      <term-item
                        v-for="item in faqTree"
                        v-once
                        :key="item.id"
                        :content="item"
                      />
                    </ul>
                  </div>

                  <div class="menu-builder__btns">
                    <button class="btn btn-primary" @click="addItemToBottom">
                      Add item
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-12 mb-5">
        <button class="btn btn-success save-menu" @click="saveAll">Save</button>

        <div class="saving-alerts" style="margin-top: 20px;">
          <div class="alert alert-success" style="display: none;">
            Data saved successful!
          </div>
          <div class="alert alert-danger" style="display: none;">
            {{ saveErrorMessage }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import '@/global/libs/jquery-sortable-lists';
import 'bootstrap';

export default {
  name: 'TermsOrderManager',

  data() {
    return {
      source: null, // source is all what we get from api
      faqTree: [],
      faqArray: [],
      saveErrorMessage: 'Error in data saving',
      orderChanged: false,
    };
  },

  mounted() {
    const self = this;
    this.getSource();

    $(document).on('click', '.menu-builder__item.has-child .menu-builder__item-btns .btn', (e) => {
      e.stopPropagation();
    });
    $(document).on('click', '.menu-builder__item-input input', function () {
      $(this).focus();
    });
    $(document).on('click', '.menu-builder__item-btns .btn-delete', function () {
      if (window.confirm('Do you really want to delete this menu item?')) {
        $(this).append('<span class="btn-loader"></span>');
        self.deleteItem($(this).closest('.menu-builder__item-wrap').data('id'));
      }
    });
    $(document).on('click', '.menu-builder__item-btns .btn-edit', function () {
      const menuItemId = $(this).closest('.menu-builder__item-wrap').data('id');
      const itemIndex = _.findIndex(self.faqArray, item => item.id === menuItemId);

      self.editItemPopup(self.faqArray[itemIndex]);
    });
    $(document).on('click', '.menu-builder__item-btns .btn-add', function () {
      const menuItemId = $(this).closest('.menu-builder__item-wrap').data('id');
      self.addItemInside(menuItemId);
    });

    this.$root.$on('termItemSaveExistingSuccess', (newContent) => {
      const itemIndex = _.findIndex(self.faqArray, item => item.id === newContent.id);
      self.faqArray[itemIndex] = newContent;
      $(`.menu-builder__item-wrap[data-id="${newContent.id}"]`)
        .children('.menu-builder__item')
        .find('.menu-builder__item-title > span')
        .text(newContent.name);
    });
    this.$root.$on('termItemSaveNewSuccess', (newContent, spot) => {
      const newItem = `<li class="menu-builder__item-wrap" data-id="${newContent.id}">
                      <div class="menu-builder__item">
                        <div class="menu-builder__item-inner">
                          <div class="menu-builder__item-title"><span>${newContent.name}</span></div>
                          <div class="menu-builder__item-btns">
                            <button class="btn btn-primary btn-add">Add item</button>
                            <button class="btn btn-primary btn-edit">Edit</button>
                            <button class="btn btn-danger btn-delete">Delete</button>
                          </div>
                        </div>
                      </div>
                    </li>`;
      const $parentItem = $(`.menu-builder__item-wrap[data-id="${newContent.parent_id}"]`);
      if (newContent.parent_id !== 0) {
        if ($parentItem.children('ul').length === 0) {
          $parentItem.append('<ul></ul>');
          $parentItem.children('.menu-builder__item')
            .prepend('<span class="sortableListsOpener menu-builder__item-opener"><i class="fa fa-minus"></i></span>');
          $parentItem.find('.sortableListsOpener').on('mousedown', function () {
            const li = $(this).closest('li');
            if (li.hasClass('sortableListsClosed')) {
              li.children('ul').show();
              li.addClass('sortableListsOpen').removeClass('sortableListsClosed');
              li.children('.menu-builder__item')
                .children('.menu-builder__item-opener')
                .html('<i class="fa fa-minus"></i>');
            } else {
              li.children('ul').hide();
              li.addClass('sortableListsClosed').removeClass('sortableListsOpen');
              li.children('.menu-builder__item')
                .children('.menu-builder__item-opener')
                .html('<i class="fa fa-plus"></i>');
            }
            return false;
          });
        }
        $parentItem.children('ul').append(newItem);
      } else if (spot === 'top') {
        $('.menu-builder-inner > ul').prepend(newItem);
      } else {
        $('.menu-builder-inner > ul').append(newItem);
      }

      this.faqArray.push(newContent);
    });
  },

  destroyed() {
    $(document).off('click', '.menu-builder__item.has-child .menu-builder__item-btns .btn');
    $(document).off('click', '.menu-builder__item-btns .btn-delete');
    $(document).off('click', '.menu-builder__item-btns .btn-edit');
    $(document).off('click', '.menu-builder__item-btns .btn-add');
    this.$root.$off('termItemSaveNewSuccess');
    this.$root.$off('termItemSaveExistingSuccess');
    $('#sortableListsBase').remove();
  },

  methods: {
    getSource() {
      if (this.$refs.spinner) { this.$refs.spinner.show(); }
      this.$apiHttp.get(`${this.$config.app_api.prefix}vocabularies/${this.$route.params.id}?with[]=terms&tree=true`)
        .then((response) => {
          this.source = response.data;
          this.faqTree = _.sortBy(response.data.terms, 'weight');
          this.faqArray = this.treeToList(this.faqTree);
          if (this.$refs.spinner) { this.$refs.spinner.hide(); }

          setTimeout(() => {
            this.initSortableList();
          }, 300);
        })
        .catch((error) => {
          console.error(error);
          if (this.$refs.spinner) { this.$refs.spinner.hide(); }
        });
    },
    treeToList(tree) {
      const list = [];
      const treeLevelExecute = (levelArr) => {
        for (let i = 0; i < levelArr.length; i += 1) {
          const item = levelArr[i];
          list.push({
            id: item.id,
            name: item.name,
            parent_id: item.parent_id,
            weight: item.weight,
            vocabulary_id: item.vocabulary_id,
          });
          if (item.children && item.children.length) {
            treeLevelExecute(item.children);
          }
        }
      };
      treeLevelExecute(tree);
      return list;
    },
    initSortableList() {
      const self = this;
      const options = {
        placeholderClass: 'menu-builder__item-placeholder',
        hintClass: 'menu-builder__item-hint',
        ignoreClass: 'btn',
        opener: {
          active: true,
          as: 'html',
          close: '<i class="fa fa-minus"></i>',
          open: '<i class="fa fa-plus"></i>',
          openerClass: 'menu-builder__item-opener',
        },
        onChange(cEl) {
          const elementId = cEl.data('id');
          const $parentEl = cEl.parent('ul').parent();
          let parentElId = 0;
          const itemIndex = _.findIndex(self.faqArray, item => item.id === elementId);
          if (!$parentEl.hasClass('menu-builder-inner')) {
            parentElId = $parentEl.data('id');
          }
          self.faqArray[itemIndex].parent_id = parentElId;
          $parentEl.children('ul').children('li').each(function (index) {
            const liId = $(this).data('id');
            const liIndex = _.findIndex(self.faqArray, item => item.id === liId);
            self.faqArray[liIndex].weight = index;
          });
          self.orderChanged = true;
        },
      };
      $('.menu-builder-inner > ul').sortableLists(options);
    },
    addItemToTop() {
      const itemsInParent = _.filter(this.faqArray, item => item.parent_id === 0);
      const minWeightObj = _.minBy(itemsInParent, item => item.weight);
      this.newItemPopup(0, minWeightObj ? minWeightObj.weight - 1 : 0, 'top');
    },
    addItemToBottom() {
      const itemsInParent = _.filter(this.faqArray, item => item.parent_id === 0);
      const maxWeightObj = _.maxBy(itemsInParent, item => item.weight);
      this.newItemPopup(0, maxWeightObj ? maxWeightObj.weight + 1 : 0, 'bottom');
    },
    addItemInside(parentId) {
      const itemsInParent = _.filter(this.faqArray, item => item.parent_id === parentId);
      const maxWeightObj = _.maxBy(itemsInParent, item => item.weight);
      this.newItemPopup(parentId, maxWeightObj ? maxWeightObj.weight + 1 : 0, 'bottom');
    },
    editItemPopup(content) {
      this.$root.$emit('termItemSetParams', content, 'edit');
    },
    newItemPopup(parentId, weight, spot) {
      const content = {
        parent_id: parentId,
        weight,
        vocabulary_id: this.$route.params.id,
        spot,
      };
      this.$root.$emit('termItemSetParams', content, 'new');
    },
    saveAll() {
      $('.saving-alerts .alert').hide();
      $('.btn-success.save-menu').append('<span class="btn-loader"></span>');
      this.$apiHttp.post(`${this.$config.app_api.prefix}terms/${this.$route.params.id}/terms/bulk-update`, {
        items: this.faqArray,
      }, {
        headers: {
          'content-type': 'application/json',
        },
      }).then(() => {
        console.log('items saved');
        $('.btn-success.save-menu .btn-loader').remove();
        $('.saving-alerts .alert-success').show();
        this.orderChanged = false;
      }).catch((error) => {
        console.error(error);
        $('.btn-success.save-menu .btn-loader').remove();
        $('.saving-alerts .alert-danger').show();
      });
    },
    deleteItem(itemId) {
      const self = this;
      this.$apiHttp.delete(`${this.$config.app_api.prefix}terms/${itemId}`)
        .then(() => {
          const arrayRemove = [];
          arrayRemove.push(itemId);
          $(`.menu-builder__item-wrap[data-id="${itemId}"]`).find('.menu-builder__item-wrap').each(function () {
            arrayRemove.push($(this).data('id'));
          });
          _.remove(self.faqArray, (item) => {
            for (let i = 0; i < arrayRemove.length; i += 1) {
              if (arrayRemove[i] === item.id) {
                return true;
              }
            }
            return false;
          });
          $(`.menu-builder__item-wrap[data-id="${itemId}"]`).remove();
        })
        .catch((error) => {
          console.error(error);
        });
    },
  },
};
</script>



// WEBPACK FOOTER //
// TermsOrder.vue?3e835d3f